import UgcDesignView from "./DesignView";

export default UgcDesignView;
